import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from './auth.service';
import {SharedService} from './shared.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {HomeService} from './home/home.service';
import {Router} from '@angular/router';
import {  AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy, OnInit {
    acceptedLanguages: any;
    title = 'app';
    data;
    admin = false;

    translateLanguage;

    // parameters extracted from local storage
    isSalesMode;
    sessionData;
    userType;

    loginObject;
    username: string;
    password: string;

    loginError: string;


    constructor(private authService: AuthService,
                private sharedService: SharedService,
                private translate: TranslateService,
                private toastr: ToastrService,
                private homeService: HomeService,
                private router: Router) {
        const temp = localStorage.getItem('sessionData');
        this.sharedService.updateUserType('simpleTravel');
        if (temp) {
            const sessionData = JSON.parse(temp);
            this.acceptedLanguages = sessionData.acceptedLanguages.split(',');
            this.translateLanguage = sessionData.language;
            this.sessionData = sessionData;
            this.isSalesMode = sessionData.isSalesMode;
            this.userType = sessionData.homepage.type;
            this.sharedService.updateUserType(sessionData.homepage.type);
            this.authService.setSession(sessionData);
        } else {
            this.homeService.setSessionData().subscribe(sessionData => {
                this.sessionData = sessionData;
                localStorage.setItem('sessionData', JSON.stringify(sessionData));
                this.authService.setSession(sessionData)
                this.acceptedLanguages = sessionData.acceptedLanguages.split(',');
                this.translateLanguage = sessionData.language;
                this.isSalesMode = sessionData.isSalesMode;
                this.userType = sessionData.homepage.type;
                this.sharedService.updateUserType(sessionData.homepage.type);
                this.authService.setSession(sessionData);
            });
        }
        if (this.translateLanguage === "") {
          this.translateLanguage = this.sessionData.defaultLanguage;
          this.translate.use(this.translateLanguage);
        }else {
          this.translate.use(this.translateLanguage);
        }

    }

    changeLanguage(language) {
        this.authService.setLanguage(language).subscribe(
          done => {
            let tempSessionData = JSON.parse(localStorage.getItem('sessionData'));
            tempSessionData.language = language;
            this.authService.setSession(tempSessionData);
            localStorage.setItem('sessionData', JSON.stringify(tempSessionData));
            this.translate.use(language);
            this.translateLanguage = language;
          }
        );
        // TODO How to use the return language? I just want to have string as result
        // TODO Clean-up all console.log - or are they away when development = false?
        // console.log(languageNew);

        // this.translate.get('simple-travel-form.testMessage').subscribe(
        //   done => console.log(done)
        // )
    }

    login(username, password) {
        this.loginObject.username = username;
        this.loginObject.password = password;
        console.log(this.loginObject);
        this.authService.login(this.loginObject).subscribe(
            // tslint:disable-next-line:max-line-length
            done => {
                console.log(done), document.getElementById('close-modal').click(), this.toastr.success('Logged in !'), this.admin = true;
            },
            err => {
                console.log(err),
                    this.admin = false;
                this.loginError = 'User not found!';
                this.toastr.error('Incorrect username or password');
            }
        );
    }

    logout() {
        this.authService.logout().subscribe(
            done => {
                this.authService.refresh(),
                    this.toastr.warning('Logged out!');
                this.admin = false;
            }
        );
    }

    // on init it will be checked if addmin is loged or user
    ngOnInit() {
        // var adm = localStorage.getItem('sessionId')
        // if(adm != undefined){
        //   if(adm){
        //     document.getElementById('mode').style.color = "green"
        //     document.getElementById('mode').innerHTML = "Admin Modus"
        //     this.admin = true;
        //   }else{
        //     document.getElementById('mode').innerHTML = "Besucher Modus"
        //     document.getElementById('mode').style.color = "grey"
        //     this.admin = false;
        //   }
        // }

        const temp = localStorage.getItem('sessionData');
        if (temp) {
            const sessionData = JSON.parse(temp);
            if (sessionData.isLoggedIn === true) {
                this.admin = true;
            } else {
                this.admin = false;
            }
        }

        this.authService.refresh();

        this.loginObject = {
            username: '',
            password: ''
        };
    }

    changeUserType(userType) {
        if (this.isSalesMode === true) {
            this.sessionData.homepage.type = userType;
            this.sharedService.changeSessionData(this.sessionData).subscribe(session => {
                    this.authService.setSession(session);
                    this.sharedService.updateUserType(session.homepage.type);
                    localStorage.setItem('sessionData', JSON.stringify(session));
                    this.userType = userType;
                    this.router.navigate(['']);
                },
                err => console.log(err)
            );
        }
    }

    ngOnDestroy() {
        // Called once, before the instance is destroyed.
        sessionStorage.removeItem('session');
        localStorage.removeItem('sessionData');
        localStorage.removeItem('sessionId');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts